import { ChangeDetectionStrategy, Component, OnInit, Inject, ViewEncapsulation, ViewChild, ElementRef, EventEmitter, Input, Output } from '@angular/core';
import * as XLSX from 'xlsx';
import { FileUploadService } from './file-upload.service';
import { OneSnackBarService, OneSnackBarType } from '@one/angular-kit/modal';
// TODO Rename and put in its own module

@Component({
  selector: 'dl-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss'],

  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FileUploadComponent implements OnInit {
  public title = 'XlsRead';
  public file: File;
  public arrayBuffer: any;
  public filelist: any;
  public fileSizeFlag = true;
  @ViewChild('fileDropRef', { static: false }) public fileDropEl: ElementRef;
  public files: any[] = [];
  public dataTosend: any;
  public csvRecords: any[] = [];
  public isCheckOneFileFlag = true;
  @Output() public dataToSendImportComp = new EventEmitter<object>();
  public constructor(private fileuploadService: FileUploadService, private readonly oneSnackBar: OneSnackBarService) {}

  public ngOnInit(): void {
    // this.fileDropEl.nativeElement.disabled = false;
  }
  /**
   * on file drop handler
   */
  public onFileDroppedandSelect($event: any): void {
    if (this.isCheckOneFileFlag) {
      this.addfile($event);
    }
  }

  /**
   * Delete file from files list
   * @param index (File index)
   */
  public deleteFile(index: number): void {
    this.files.splice(index, 1);
    this.dataTosend = {
      fileDetails: {},
      columnDetails: [],
      action: 'delete'
    };
    this.fileDropEl.nativeElement.value = '';
    this.fileDropEl.nativeElement.disabled = false;
    this.isCheckOneFileFlag = true;
    this.dataToSendImportComp.emit(this.dataTosend);
    this.fileuploadService.sendFileUploadedData(this.dataTosend);
  }

  /**
   * Convert Files list to normal array list
   * @param files (Files List)
   */
  public prepareFilesList(files: Array<any>): void {
    this.files.push(files);
  }

  /**
   * format bytes
   * @param bytes (File size in bytes)
   * @param decimals (Decimals point)
   */
  public formatBytes(bytes: number, decimals: number = 2, fileName: any = 'Sample'): string {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    const sizeInNum = parseFloat((bytes / Math.pow(k, i)).toFixed(dm));
    const typeofFile = sizes[i];

    if (sizeInNum <= 0 || sizeInNum >= 15 && typeofFile === 'MB') {
      this.oneSnackBar.open(`The file ${fileName.name} could not be uploaded. The maximum file size is 15 MB and should not be empty.`, OneSnackBarType.ERROR);
      this.fileSizeFlag = false;
    } else {
      this.fileSizeFlag = true;
    }

    return sizeInNum + ' ' + typeofFile;
  }

  public isValidCSVOrEXLFile(file: any): boolean {
    if (file.name.endsWith('.csv') || file.name.endsWith('.xlsx') || file.name.endsWith('.xls')) {
      return true;
    } else {
      this.oneSnackBar.open(`The file ${file.name} could not be uploaded. Only the file formats .xlsx and .csv are allowed.`, OneSnackBarType.ERROR);
    }
  }

  public addfile(event: any): void {
    this.formatBytes(event.size, undefined, event);
    if (this.isValidCSVOrEXLFile(event) && this.fileSizeFlag && this.isCheckOneFileFlag) {
      let jsData;
      this.prepareFilesList(event);
      this.file = event;
      const fileReader = new FileReader();
      fileReader.readAsArrayBuffer(this.file);
      fileReader.onload = e => {
        this.arrayBuffer = fileReader.result;
        const data = new Uint8Array(this.arrayBuffer);
        const arr = new Array();
        for (let i = 0; i !== data.length; ++i) arr[i] = String.fromCharCode(data[i]);
        const bstr = arr.join('');
        const workbook = XLSX.read(bstr, { type: 'binary' });
        const FIRST_SHEET_NAME = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[FIRST_SHEET_NAME];
        // console.log(XLSX.utils.sheet_to_json(worksheet, { raw: false }));
        jsData = XLSX.utils.sheet_to_json(worksheet, { raw: false });
        this.fileuploadService.getSheetToJSONData(jsData);
        const arraylist = XLSX.utils.sheet_to_json(worksheet, { raw: true });

        this.filelist = [];
        this.dataTosend = {
          fileDetails: event,
          columnDetails: Object.keys(arraylist[0]),
          action: 'Insert'
        };
        this.fileDropEl.nativeElement.disabled = true;
        this.isCheckOneFileFlag = false;
        this.dataToSendImportComp.emit(this.dataTosend);
        this.fileuploadService.sendFileUploadedData(this.dataTosend);
      };
    } else {
      // console.log('File is not .xlsx or .csv format');
      event = '';
      this.fileSizeFlag = true;
    }
  }
}
